export default "__VITE_ASSET__eXB4mXpg__"